var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('TopSection',{attrs:{"title":_vm.$t('TOP-01.scene.header'),"no-x-margin":"","more-link-text":_vm.$t('TOP-01.scene.seeMore'),"more-link-to":_vm.url('SCENE_LIST'),"always-more-button":"","ga-parts-type":"シーン"}},[(_vm.sceneList)?_c('div',{staticClass:"mx-4 mb-8 grid grid-cols-2 gap-1 md:mx-0 md:flex md:flex-wrap"},_vm._l((_vm.sceneList),function(scene,index){
var _obj;
return _c('AppLink',{key:index,staticClass:"block border py-2 text-center md:px-4",attrs:{"to":{
          path: _vm.url('ITEM_LIST'),
          query: ( _obj = {}, _obj[_vm.PRODUCT_PARAM_QUERIES.TAG] = scene, _obj[_vm.PRODUCT_PARAM_QUERIES.QTY] = _vm.BooleanLike.TRUE, _obj ),
        }},nativeOn:{"click":function($event){
        var _obj;
_vm.sendGaEvent(
            'シーン',
            {
              path: _vm.url('ITEM_LIST'),
              query: ( _obj = {}, _obj[_vm.PRODUCT_PARAM_QUERIES.TAG] = scene, _obj[_vm.PRODUCT_PARAM_QUERIES.QTY] = _vm.BooleanLike.TRUE, _obj ),
            },
            scene
          )}}},[(_vm.isSmartPhone && scene === 'キャンプ＆バーベキューに')?_c('span',[_vm._v("キャンプ＆BBQに")]):_c('span',[_vm._v(_vm._s(scene))])])}),1):_vm._e()]),_vm._v(" "),_c('TopSection',{attrs:{"title":_vm.$t('TOP-01.keyword.header'),"no-x-margin":"","more-link-text":_vm.$t('TOP-01.keyword.seeMore'),"more-link-to":_vm.url('KEYWORD_LIST'),"always-more-button":"","ga-parts-type":"キーワード"}},[(_vm.keywordList)?_c('div',{staticClass:"mx-4 mb-8 grid grid-cols-2 gap-1 md:mx-0 md:flex md:flex-wrap"},_vm._l((_vm.keywordList),function(keyword,index){
          var _obj;
return _c('AppLink',{key:index,staticClass:"block border p-2 text-center md:px-4",attrs:{"to":{
          path: _vm.url('ITEM_LIST'),
          query: ( _obj = {}, _obj[_vm.PRODUCT_PARAM_QUERIES.TAG] = keyword, _obj[_vm.PRODUCT_PARAM_QUERIES.QTY] = _vm.BooleanLike.TRUE, _obj ),
        }},nativeOn:{"click":function($event){
        var _obj;
_vm.sendGaEvent(
            'キーワード',
            {
              path: _vm.url('ITEM_LIST'),
              query: ( _obj = {}, _obj[_vm.PRODUCT_PARAM_QUERIES.TAG] = keyword, _obj[_vm.PRODUCT_PARAM_QUERIES.QTY] = _vm.BooleanLike.TRUE, _obj ),
            },
            keyword
          )}}},[_vm._v("\n        "+_vm._s(keyword)+"\n      ")])}),1):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }